angular.module('jv.Admin.Users.NavService', [])
    .service('navInjectionSVC', function(prepareAjaxCall, jvAdminUsersUrls) {
        this.getUserNavigation = function(callback, fail) {
            var options = {};
            options = {
                'ajaxtype': 'getAdminUserNavigration',
                'url': jvAdminUsersUrls.adminNavUrl
            };
            function transformResponse(response) {
                var data = {};
                if (response) {
                    angular.forEach(response, function(navItem) {
                        if (navItem.key === 'ADMIN_MAIN_NAV_USERS') {
                            angular.forEach(navItem.subMenuItems, function(sec) {
                                if (sec.key === 'ADMIN_USERS_SUB_NAV_EMPLOYEES') {
                                    data.showEmployee = true;
                                } else if (sec.key === 'ADMIN_USERS_SUB_NAV_AGENCIES') {
                                    data.showAgency = true;
                                } else if (sec.key === 'ADMIN_USERS_SUB_NAV_SETTINGS') {
                                    data.showSettings = true;
                                } else if (sec.key === 'ADMIN_USERS_SUB_NAV_EMPLOYEE_DATA_SYNC_LOG') {
                                    data.showDataSyncLog = true;
                                } else if (sec.key === 'ADMIN_USERS_SUB_NAV_EMPLOYEE_DATA_SYNC_SETTINGS') {
                                    data.showDataSyncSettings = true;
                                } else if (sec.key === 'ADMIN_USERS_SUB_NAV_ROLES') {
                                    data.showRoles = true;
                                } else if (sec.key === 'ADMIN_USERS_SUB_NAV_DELETE_THRESHOLD_SETTINGS') {
                                    data.showDeleteThresholdSettings = true;
                                } else if (sec.key === 'ADMIN_USERS_SUB_NAV_ACCESS_GROUPS') {
                                    data.showAccessGroups = true;
                                }
                            });
                        }
                    });
                }
                callback(data);
            }
            prepareAjaxCall({}, options, transformResponse, fail);
        };
    });
